import TitledPanel from '../../core/TitledPanel';
import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import SelectProjectDialog from '../../core/project/SelectProjectDialog';
import ProjectLink from '../../vocabulary/core/ProjectLink';
import SecondaryButton from '../../core/SecondaryButton';
import SearchSelect from '../../core/SearchSelect';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../../core/CancelButton';
import { globalStyles as styles } from '../../core/style/gstheme';
import { Typography } from '@material-ui/core';
import { getGraphFromProject, getProjectFromGraph, computeComponentIcon } from '../../core/utils/utils';

class FindComponentDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            lang: props.defaultLang,
            project: getProjectFromGraph(this.props.graph),
            selectProject: false
        };
    }

    handleClickOpen = () => this.setState({
        open: true,
        selectProject: false,
        project: getProjectFromGraph(this.props.graph)
    });

    computeSearch = (value) => {
        const graph = this.props.enableProjectSelection && this.state.project ?
            getGraphFromProject(this.state.project)
            :
            this.props.graph;
        let fullSearch =
        {
            search: [
                {
                    predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                    value: [
                        "http://www.w3.org/2004/02/skos/core#ConceptScheme",
                        "http://www.w3.org/2004/02/skos/core#Collection",
                        "http://www.w3.org/2004/02/skos/core#OrderedCollection",
                        "https://grafsync.graphifi.com/schema/gs/Dataset"
                    ]
                },
                {
                    predicate: "http://purl.org/dc/terms/title",
                    value: value,
                    isExactMatch: false
                }
            ],
            graph: [graph],
            exclude: this.props.exclude,
            language: this.state.lang,
            sort: ["http://purl.org/dc/terms/title"],
            searchMode: "Compliant",
            predicates: [
                "http://purl.org/dc/terms/title",
                "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
            ]
        };
        return fullSearch;
    };

    addComponent = (id) => {
        this.props.onAddComponent(id, this.state.project);
        this.exitAddComponent();
    };

    changeLanguage = (lang) => this.setState({ lang });

    exitAddComponent = () => this.setState({
        open: false,
        selectProject: false
    });

    changeProject = () => this.setState({ selectProject: true });

    exitProject = () => this.setState({ selectProject: false });

    setProject = (project) => this.setState({
        project,
        selectProject: false
    });

    render() {

        const { classes, defaultLang, exclude, enableProjectSelection } = this.props;
        const { project, selectProject, lang } = this.state;

        // We keep this as taxonomy projects only for now
        if (selectProject) {
            return <SelectProjectDialog
                open={true}
                onAddProject={this.setProject}
                onExitProject={this.exitProject}
                projectTypes={[
                    "https://grafsync.graphifi.com/schema/gs/DataProject",
                    "https://grafsync.graphifi.com/schema/gs/TaxonomyProject"
                ]}
                label="Choose Project"
                includeIcon={false} />;
        }

        return (
            <React.Fragment>
                <SecondaryButton dataTest="add-component" onClick={this.handleClickOpen}>Add</SecondaryButton>
                <Dialog
                    data-test="add-component-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.smallDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open} onClose={this.exitFindResource} aria-labelledby="find-component-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="find-component-dialog-title">Target to Select From</DialogTitle>
                    <DialogContent style={{ height: '400px', overflow: 'hidden' }}>
                        {enableProjectSelection &&
                            <div style={{ width: 'calc(100% - 12px)', border: 'solid 1px #c0c0c0', borderRadius: 4, padding: 6, marginBottom: 12 }}>
                                <div style={{ display: 'flex', width: '100%' }}>
                                    <div style={{ flex: 1, paddingTop: 12, overflow: 'hidden', marginRight: 12 }}>
                                        <ProjectLink
                                            id={project}
                                            defaultLang={defaultLang}
                                            graph={getGraphFromProject(project)}
                                            key={project} />
                                    </div>
                                    <div style={{ flex: 0, width: 100 }}>
                                        <SecondaryButton dataTest="change-project" onClick={this.changeProject}>Change</SecondaryButton>
                                    </div>
                                </div>
                            </div>
                        }
                        <TitledPanel dataTest="project-language" title="Language">
                            <ProjectLanguageSelector
                                selectedLang={lang}
                                includeLabel={false}
                                onSelect={this.changeLanguage} />
                        </TitledPanel>
                        <div style={{ height: 300 }}>
                            <SearchSelect
                                dataTest="find-component"
                                focus={true}
                                key={lang}
                                sortProp="title"
                                wrapped={true}
                                exclude={exclude}
                                search={(value) => this.computeSearch(value)}
                                listDisplay={(result, lang) => {
                                    if (result.title[lang]) {
                                        const title = result.type.includes("DataSet") ?
                                            "Dataset"
                                            :
                                            result.type.includes("ConceptScheme") ?
                                                "Concept Scheme"
                                                :
                                                result.type.includes("OrderedCollection") ?
                                                    "Ordered Collection"
                                                    :
                                                    "Unordered Collection";
                                        const icon = computeComponentIcon(result.type);
                                        return <div>
                                            <Typography data-test="result-label" variant="body2" style={{ textIndent: '-1.3em', marginLeft: '2.4em' }}>
                                                <Tooltip placement="left" title={title}>
                                                    <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
                                                        {icon}
                                                    </span>
                                                </Tooltip>
                                                <span data-test={result.type + "-entry"}>
                                                    <Tooltip placement="left" title={result.id}>
                                                        <span style={{ marginLeft: 12 }}>
                                                            {result.title[lang]}
                                                        </span>
                                                    </Tooltip>
                                                </span>
                                            </Typography>
                                        </div>;
                                    }
                                    else {
                                        return <Typography data-test="result-label" variant="body2">{result.id}</Typography>;
                                    }
                                }}
                                isClickableResult={(result) => {
                                    if (result.invalid) return false;
                                    return true;
                                }}
                                title="Filter components"
                                lang={lang}
                                chosen={this.addComponent} />
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddComponent} />
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

FindComponentDialog.defaultProps = {
    enableProjectSelection: false,
    exclude: []
};

FindComponentDialog.propTypes = {
    classes: PropTypes.object,
    graph: PropTypes.string.isRequired,
    exclude: PropTypes.array,
    defaultLang: PropTypes.string.isRequired,
    onAddComponent: PropTypes.func.isRequired
};

export default withStyles(styles)(FindComponentDialog);